import React from "react";
import PropTypes from "prop-types";
import { capitalizarTexto } from "../../../shared/utils/formatador";
import { calcularIdade } from "../../../shared/utils/calcularIdade";

const TabDadosPrincipais = ({ dadosCompletos }) => {
  const extrairListaCns = (valorCns) => {
    if (Array.isArray(valorCns)) {
      return valorCns
        .map((item) => {
          if (typeof item === "string" || typeof item === "number") {
            return String(item);
          }

          if (item && typeof item === "object") {
            return item.cns || item.numero || "";
          }

          return "";
        })
        .filter(Boolean);
    }

    if (typeof valorCns === "string" || typeof valorCns === "number") {
      return [String(valorCns)];
    }

    if (valorCns && typeof valorCns === "object") {
      const cnsUnico = valorCns.cns || valorCns.numero;
      return cnsUnico ? [String(cnsUnico)] : [];
    }

    return [];
  };

  const obito =
    dadosCompletos?.obito === true
      ? "Sim"
      : dadosCompletos?.obito === false
        ? "Não"
        : "-";
  const nomeMae = dadosCompletos?.nomeMae || "—";
  const cnsLista = extrairListaCns(dadosCompletos?.cns);
  const cns = cnsLista.length > 0 ? cnsLista.join(", ") : "—";

  const nome = dadosCompletos?.nome || "—";
  const cpf = dadosCompletos?.cpf || "—";
  const dataNascimento = dadosCompletos?.dataNascimento || null;

  const telefones = Array.isArray(dadosCompletos?.telefone)
    ? dadosCompletos.telefone
    : [];
  const emails = Array.isArray(dadosCompletos?.email) ? dadosCompletos.email : [];
  const enderecos = Array.isArray(dadosCompletos?.endereco)
  ? dadosCompletos.endereco
  : dadosCompletos?.Endereco
    ? [{ address: dadosCompletos.Endereco }]
    : [];
  const pacienteId = dadosCompletos?.id || "—";

  const formatarData = (dataISO) => {
    if (!dataISO) return "—";
    const [ano, mes, dia] = dataISO.split("T")[0].split("-");
    return `${dia}/${mes}/${ano}`;
  };

  return (
      <div className="dados-pessoais p-3 d-grid gap-4">
        <div className="informacoes-pessoais">
          <h5 className="mb-3">Informações Pessoais</h5>
          <hr />
          <div className="row g-3">
            <div className="col-6 col-md-4">
              <strong>ID</strong>
              <div className="fw-semibold">{pacienteId || "Não informado"}</div>
            </div>

            <div className="col-12 col-md-4">
              <strong>Paciente</strong>
              <div className="fw-semibold text-dark">
                {capitalizarTexto(nome) || "Não informado"}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <strong>Nome da mãe</strong>
              <div className="fw-semibold text-dark">
                {capitalizarTexto(nomeMae) || "Não informado"}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <strong>Data de Nascimento</strong>
              <div className="fw-semibold text-dark">
                {formatarData(dataNascimento) || "Não informado"}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <strong>Idade</strong>
              <div className="fw-semibold text-dark">
                {calcularIdade(dataNascimento) || "Não informado"}
              </div>
            </div>
            {obito === "Sim" && (
              <div className="col-12 col-md-3">
                <strong>Óbito</strong>
                <div className="fw-semibold text-dark">{obito}</div>
              </div>
            )}

            <div className="col-6 col-md-4">
              <strong>CPF</strong>
              <div className="fw-semibold">{cpf || "Não informado"}</div>
            </div>

            <div className="col-12 col-md-4">
              <strong>CNS</strong>
              <div className="fw-semibold text-dark">{cns || "Não informado"}</div>
            </div>
          </div>
        </div>
        <div className="contatos">
          <h5 className="mb-3">Contatos</h5>
          <hr />
          <div className="row g-3">
            <div className="col-12 col-md-4">
              <strong>Telefones</strong>
              <div className="fw-semibold text-dark">
                <ul className="mb-0">
                  {telefones.length > 0 ? (
                    telefones.map((t, i) => <li key={i}>{t.number}</li>)
                  ) : (
                    <li>Não informado</li>
                  )}
                </ul>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <strong>E-mail</strong>
              <div className="fw-semibold text-dark">
                <ul className="mb-0">
                  {emails.length > 0 ? (
                    emails.map((e, i) => <li key={i}>{e.email}</li>)
                  ) : (
                    <li>Não informado</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="enderecos">
          <strong>Endereços</strong>
          <hr />
          <div className="row g-23 align-items-center">
            <div className="mb-4">
              {enderecos.length > 0 ? (
                <ul className="mb-0">
                  {enderecos.map((end, i) => (
                    <li key={i}>
                      {capitalizarTexto(end.address) || ""},{" "}
                      {end.number || "s/n"}{" "}
                      {capitalizarTexto(end.neighborhood)
                        ? ` - ${capitalizarTexto(end.neighborhood)}`
                        : ""}{" "}
                      {end.city?.name
                        ? `- ${capitalizarTexto(end.city.name)}`
                        : ""}{" "}
                      {end.uf ? `- ${end.uf}` : ""}
                    </li>
                  ))}
                </ul>
              ) : (
                <div>—</div>
              )}
            </div>
          </div>
        </div>
      </div>
  );
};

TabDadosPrincipais.propTypes = {
  dadosCompletos: PropTypes.object,
};

export default TabDadosPrincipais;
